export const PLANS = {
  LIGHT: "light",
  CUSTOM: "custom",
  COMMERCIAL_LICENCE: "commercial_license",
};

export const PLAN_DATA = [
  {
    preTitle: "ALWAYS INCLUDED IN",
    name: "Emma",
    description:
      "Gather all sustainability data ni one place and stop worrying about compliance with various standards and regulations. Wether you are an orgnisation in manufacturing, finance, retail, or other services - Emma can be tailored to your specific needs.",
    preTitleStays: "Stays updated",
    list: ["Full set GHG database", "View only reporter", "Send calculator "],
    preTitleScales: "Scales after you",
    listScales: [
      "Unlimited activities",
      "Unlimited categories",
      "Multiple teams",
      "Support multiple reporters",
    ],
    preTitleCustomisable: "Customisable",
    listCustomisable: [
      "Onboarding",
      "Custom emission portfolio",
      "Add custom emission factor",
    ],
    pricing: {
      info: "Licensing bills monthly and includes tailored onboarding, a personal sustainability specialist, and ongoing user support. Binding time minimum 3 months.",
      price: "9000 SEK per month",
      button: "Create account",
      buttonSecondary: "Book a demo",
    },
    color: "red",
  },
];
